import utils from '@/mixins/utils.js'

export const dataFields = {
  Nome: 'no_cidadao',
  Nascimento: {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
  'Influenza Trivalente': {
    field: 'dt_aplicacao',
    callback: (value) => {
      return value !== '' ? value : ''
    },
  },
}
